import axios from 'axios';
import React, { useEffect, useState, useRef } from 'react';
import { Constants } from '../lib/const/constants';
import { PrimaryButton } from '../components/button';
import { useNavigate } from 'react-router-dom';
import { useId } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { encryptPayload } from '../utils/encryption';
import AddressSearchInput from '../components/shared/AddressSearchInput';

function UserDetails() {
  const navigate = useNavigate();
  // const location = useLocation();
  // const paramsdata = location.state || {};
  // const account_id = paramsdata?.account_id;
  const [loading, setLoading] = useState(false);
  const [details, setDetails] = useState({});
  const [titles, setTitles] = useState([]);
  const [url, setUrl] = useState();
  const [kycLoading, setkycLoading] = useState(false);
  const [smsLoading, setSmsLoading] = useState(false);
  const [emailLoading, setEmailLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const deviceId = useId();
  const pin = 123456;
  const [cameraOpen, setCameraOpen] = useState(false);
  const [stream, setStream] = useState(null);
  const [countries, setCountries] = useState([]);
  const [nationalityOpen, setNationalityOpen] = useState(false);
  const [nationalitySearch, setNationalitySearch] = useState('');

  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const nationalityRef = useRef(null);

  console.log('nationalitySearch', nationalitySearch);

  const filteredNationalities = countries.filter((c) =>
    (c.name || '').toLowerCase().includes(nationalitySearch.toLowerCase()),
  );

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (nationalityRef.current && !nationalityRef.current.contains(e.target)) {
        setNationalityOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    const countriesList = JSON.parse(sessionStorage.getItem('countries')) || [];
    if (Array.isArray(countriesList) && countriesList.length > 0) {
      setCountries(countriesList);
      return;
    }
    axios
      .get(Constants.BASE_URL + 'API-FX-102-Country', {
        headers: {
          fx_key: Constants.SUBSCRIPTION_KEY,
        },
      })
      .then((response) => {
        setCountries(response.data.data || []);
      })
      .catch((error) => {
        console.log(error.response?.data);
      });
  }, []);

  useEffect(() => {
    if (cameraOpen && videoRef.current && stream) {
      videoRef.current.srcObject = stream;
    }
  }, [cameraOpen, stream]);

  const openCamera = async () => {
    try {
      const mediaStream = await navigator.mediaDevices.getUserMedia({
        video: true,
      });

      setStream(mediaStream);
      setCameraOpen(true);
    } catch (error) {
      toast.error('Unable to access camera');
    }
  };

  const capturePhoto = () => {
    const video = videoRef.current;
    const canvas = canvasRef.current;

    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;

    const context = canvas.getContext('2d');
    context.drawImage(video, 0, 0);

    const base64Image = canvas.toDataURL('image/png').split(',')[1];

    setDetails({
      ...details,
      photo_id: base64Image,
      photo_id_file_name: 'camera_photo.png',
      photo_id_file_extension: 'png',
    });

    if (stream) {
      stream.getTracks().forEach((track) => track.stop());
    }

    setCameraOpen(false);
    toast.success('Photo captured successfully');
  };

  const submitHandler = async () => {
    let validationErrors = {};
    if (!details.title) validationErrors.title = 'Title is Required';
    if (!details.email) validationErrors.email = 'Email is Required';
    if (!details.mobile) validationErrors.mobile = 'Mobile is required';
    if (!details.first_name)
      validationErrors.first_name = 'First name is required';
    if (!details.last_name)
      validationErrors.last_name = 'Last name is required';
    if (!details.address_line1?.trim())
      validationErrors.address_line1 = 'Address is required';
    if (!details.city?.trim()) validationErrors.city = 'City is required';
    if (!details.post_code)
      validationErrors.post_code = 'Post code is required';
    if (!details.country) validationErrors.country = 'Country is required';
    if (!details.nationality)
      validationErrors.nationality = 'Nationality is required';
    if (!details.place_of_birth)
      validationErrors.place_of_birth = 'Place of Birth is required';
    if (!details.date_of_birth)
      validationErrors.date_of_birth = 'Date of Birth is required';

    if (!details.photo_id) {
      toast.error('Photo Id is required');
    }

    setErrors(validationErrors);
    if (Object.keys(validationErrors).length > 0 || !details.photo_id) {
      return;
    }

    setLoading(true);
    const dropPayload = await encryptPayload({
          screen_name: 'CREATE_ACCOUNT_1',
          meta: { enterPin: pin },
          device_id: deviceId,
          user_id: Date.now(),
          platform: 'web',
          extraParamValidation: 'trustedfromweb',
        });

    await axios
      .post(
        Constants.BASE_URL + 'API-FX-159-DROPSCREEN',
        dropPayload,
        {
          headers: {
            fx_key: Constants.SUBSCRIPTION_KEY,
          },
        },
      )
      .then((dropresponse) => {
        console.log(dropresponse.data);
        setLoading(false);
        submitHandlerNationality();
      })
      .catch((dropError) => {
        console.log(dropError.response.data);
        setLoading(false);
        toast.error(dropError.response.data.message);
      });
  };
  // console.log('details.nationality',details.nationality);
  const submitHandlerNationality = async () => {
    setLoading(true);
    if (details.email.trim() == '' || details.mobile.trim() == '') {
      toast.error('Please fill all the fields.');
      setLoading(false);


    } else {
      var titleDetails = details.title.split('_');
      const encpayload = await encryptPayload({
          title_id: titleDetails[1],
            first_name: details.first_name,
            middle_name: '',
            last_name: details.last_name,
            address_line1: details.address_line1 ?? '',
            city: details.city ?? '',
            country_code: '44',
            nationality: details.nationality,
            password: String(pin),
            password_confirmation: String(pin),
            country_id: '231',
            phone: details.mobile,
            email: details.email,
            is_banking_user: 2,
            type: 'standard',
            occupation: 'NA',
            account: 'NA',
            destination_country: 'NA',
            domain: 1,
            platform: 'web',
            extraParamValidation: 'trustedfromweb',
        });

      await axios
        .post(
          Constants.BASE_URL + 'API-FX-105-CustomerSignup',
          encpayload,
          {
            headers: {
              fx_key: Constants.SUBSCRIPTION_KEY,
            },
          },
        )
        .then(async(response) => {
          console.log(JSON.stringify(response.data.data));
          const dropencpayload = await encryptPayload({
                screen_name: 'NATIONALITY_2',
                meta: {
                  title_id: titleDetails[1],
                  first_name: details.first_name,
                  middle_name: '',
                  last_name: details.last_name,
                  country_code: '44',
                  nationality: details.nationality,
                  password: details.pin,
                  password_confirmation: details.pin,
                  country_id: '231',
                  phone: details.mobile,
                  email: details.email,
                  address_id: details.address_id,
                  photo_id: details.photo_id,
                  is_banking_user: 2,
                  type: 'standard',
                  occupation: 'NA',
                  account: 'NA',
                  destination_country: 'NA',
                },
                device_id: deviceId,
                user_id: response.data.data.id,
                platform: 'web',
                extraParamValidation: 'trustedfromweb',
              });
          axios
            .post(
              Constants.BASE_URL + 'API-FX-159-DROPSCREEN',
              dropencpayload,
              {
                headers: {
                  fx_key: Constants.SUBSCRIPTION_KEY,
                },
              },
            )
            .then((dropresponse) => {
              console.log(dropresponse.data);
              setLoading(false);
              createVirtualAccount(
                response.data.data.workspaces[0].id,
                response.data.data.workspaces[0].memberships.id,
                response.data.data.id,
              );
            })
            .catch((dropError) => {
              setLoading(false);
              toast.error(dropError.response.data.message);
            });
        })
        .catch((error) => {
          toast.error(error.response.data.message);
          setLoading(false);
        });
    }
  };
  const createVirtualAccount = async (workspaceId, membershipId, user_id) => {
    console.log('details.nationality', details.nationality);
    var titleDetails = details.title.split('_');
    setLoading(true);
    const complianceId = sessionStorage.getItem('staff_login_id');
    await axios
      .post(
        Constants.BASE_URL + 'API-FX-215-CREATE-VIRTUAL-ACCOUNT',
        {
          title: titleDetails[0],
          email: details.email,
          mobile: details.mobile,
          first_name: details.first_name,
          last_name: details.last_name,
          address_line1: details.address_line1,
          city: details.city ?? '',
          post_code: details.post_code,
          country: details.country,
          nationality: details.nationality,
          place_of_birth: details.place_of_birth,
          date_of_birth: details.date_of_birth,
          account_id: 'a4e28078-f414-4399-9159-2803affe0ebf',
          workspace_id: workspaceId,
          membershipId: membershipId,
          user_id: user_id,
          complianceId: complianceId,
          address_id: details.address_id,
          address_id_file_name: details.address_id_file_name,
          address_id_file_extension: details.address_id_file_extension,
          photo_id: details.photo_id,
          photo_id_file_name: details.photo_id_file_name,
          photo_id_file_extension: details.photo_id_file_extension,
        },
        {
          headers: {
            fx_key: Constants.SUBSCRIPTION_KEY,
          },
        },
      )
      .then((resp) => {
        resp;
        toast.success('Account Created Successfully.');
        setLoading(false);
        setTimeout(function () {
          navigate('/memberships');
        }, 2000);
      })
      .catch((err) => {
        console.log(err.response.data);
        setLoading(false);
        toast.error(err.response.data.message);
      });
  };
  const getData = async () => {
    await axios
      .get(Constants.BASE_URL + 'API-FX-101-Title', {
        headers: {
          fx_key: Constants.SUBSCRIPTION_KEY,
        },
      })
      .then((response) => {
        console.log('titlesss' + JSON.stringify(response.data.data));
        setTitles(response.data.data);
      })
      .catch((error) => {
        console.log('titlesss' + error.response.data);
      });
  };
  const generateKyc = async () => {
    if (details.mobile == null || details.mobile == '') {
      toast.error('Please enter mobile number.');
    } else {
      setkycLoading(true);
      const encryptedPayload = await encryptPayload({
        "user_id": details.mobile,
        "platform": 'web',
        "extraParamValidation": 'trustedfromweb'
      });
      await axios
        .post(
          Constants.BASE_URL + 'API-FX-187-SUMSUB-URL',
          encryptedPayload,
          {
            headers: {
              fx_key: Constants.SUBSCRIPTION_KEY,
            },
          },
        )
        .then((resp) => {
          setUrl(resp.data.url);
          setkycLoading(false);
        })
        .catch((err) => {
          toast.error(err.response.data);
          setkycLoading(false);
        });
    }
  };
  const copyToClipBoard = async () => {
    navigator.clipboard.writeText(url);
    toast.success('Copied');
  };

  const getErrorMessage = (err, fallback) => {
    const data = err.response?.data;
    if (typeof data === 'string' && data) return data;
    return data?.message || data?.error || err.message || fallback;
  };

  const sendSms = async () => {
    if (!details.mobile) {
      toast.error('Please enter mobile number.');
      return;
    }
    setSmsLoading(true);
    await axios
      .post(
        Constants.BASE_URL + 'API-FX-169-SendAgentSms',
        {
          "mobile": details.mobile,
          "type": "sms",
          "subject": "Your KYC Verification",
          "message_content": "Hi, please find your kyc verification below. Please complete the process. " + " " + url
        },
        {
          headers: {
            fx_key: Constants.SUBSCRIPTION_KEY,
          },
        },
      )
      .then((resp) => {
        toast.success(resp.data?.message || 'SMS sent successfully');
      })
      .catch((err) => {
        toast.error(getErrorMessage(err, 'Failed to send SMS'));
      })
      .finally(() => setSmsLoading(false));
  };

  const sendEmail = async () => {
    if (!details.email) {
      toast.error('Please enter email.');
      return;
    }
    setEmailLoading(true);
    await axios
      .post(
        Constants.BASE_URL + 'API-FX-169-SendAgentSms',
        {
          email: details.email,
          "type": "email",
          "subject": "Your KYC Verification",
          "message_content": "Hi, please find your kyc verification below. Please complete the process. " + " " + url
        },
        {
          headers: {
            fx_key: Constants.SUBSCRIPTION_KEY,
          },
        },
      )
      .then((resp) => {
        toast.success(resp.data?.message || 'Email sent successfully');
      })
      .catch((err) => {
        toast.error(getErrorMessage(err, 'Failed to send email'));
      })
      .finally(() => setEmailLoading(false));
  };

  const handleFileUpload = async (e, fieldName) => {
    const file = e.target.files[0];
    if (!file) return;

    const fileName = file.name;
    const extension = file.name.split('.').pop();

    const reader = new FileReader();

    reader.onload = () => {
      const base64String = reader.result.split(',')[1];

      setDetails({
        ...details,
        [fieldName]: base64String,
        [`${fieldName}_file_name`]: fileName,
        [`${fieldName}_file_extension`]: extension,
      });
    };

    reader.readAsDataURL(file);
  };
  useEffect(() => {
    getData();
  }, []);
  return (
    <div className="my-2 flex justify-center">
      <ToastContainer />

      <div className="w-full bg-white rounded-2xl p-8 shadow-sm">
        <span className="text-lg font-semibold text-[#252528]">
          Enter User Details
        </span>

        <div className="mt-6 space-y-4">
          <select
            className="w-full p-3 outline-none rounded-2xl border text-[#252528] font-semibold placeholder:text-sm placeholder:text-slate-700"
            onChange={(e) => {
              setDetails({ ...details, title: e.target.value });
              setErrors({ ...errors, title: '' });
            }}
          >
            <option>---Select Title---</option>
            {titles &&
              titles.length != 0 &&
              titles.map((title) => {
                return (
                  <option key={title.id} value={title.name + '_' + title.id}>
                    {title.name}
                  </option>
                );
              })}
          </select>
          {errors.title && (
            <p className="text-red-500 text-sm mt-1">{errors.title}</p>
          )}

          <input
            type="email"
            required={true}
            placeholder={'Email'}
            className="w-full p-3 outline-none rounded-2xl border text-[#252528] font-semibold placeholder:text-sm placeholder:text-slate-700"
            onChange={(e) => {
              setDetails({ ...details, email: e.target.value });
              setErrors({ ...errors, email: '' });
            }}
          />
          {errors.email && (
            <p className="text-red-500 text-sm mt-1">{errors.email}</p>
          )}

          <div className="flex gap-3">
            <input
              type="number"
              required={true}
              placeholder={'Mobile'}
              className="w-full p-3 outline-none rounded-2xl border text-[#252528] font-semibold placeholder:text-sm placeholder:text-slate-700"
              onChange={(e) => {
                setDetails({ ...details, mobile: e.target.value });
                setErrors({ ...errors, mobile: '' });
              }}
            />
            <PrimaryButton
              label={'Generate KYC Link'}
              style={{ width: '40%' }}
              onClick={generateKyc}
              loading={kycLoading}
            />
          </div>
          {errors.mobile && (
            <p className="text-red-500 text-sm mt-1">{errors.mobile}</p>
          )}

          {url && (
            <div className="flex gap-3">
              <>
                <input
                  type="text"
                  disabled={true}
                  required={true}
                  placeholder={'KYC URL'}
                  value={url}
                  className="w-full p-3 outline-none rounded-2xl border bg-[#f0f0f0] text-[#252528] font-semibold placeholder:text-sm placeholder:text-slate-700"
                />
                <PrimaryButton
                  label={'Copy'}
                  style={{ width: '20%' }}
                  onClick={copyToClipBoard}
                />
                <PrimaryButton
                  label={'Send SMS'}
                  style={{ width: '20%' }}
                  onClick={sendSms}
                  loading={smsLoading}
                />
                <PrimaryButton
                  label={'Send Email'}
                  style={{ width: '20%' }}
                  onClick={sendEmail}
                  loading={emailLoading}
                />
              </>
            </div>
          )}

          <div className="flex gap-4">
            <div className="w-[40%]">
              <input
                type="file"
                accept="image/*,.pdf"
                onChange={(e) => {
                  handleFileUpload(e, 'photo_id');
                }}
                className="hidden"
                id="photoUpload"
              />

              <label
                htmlFor="photoUpload"
                onClick={() => {
                  if (stream) {
                    stream.getTracks().forEach((track) => track.stop());
                  }
                  setCameraOpen(false);
                }}
                className="border-2 border-dashed border-gray-300 rounded-lg p-6 flex items-center justify-center cursor-pointer bg-[#F7F9FB] min-h-[120px]"
              >
                <p className="font-medium text-[#0B214E]">Upload Photo ID</p>
              </label>

              {details.photo_id && (
                <p className="text-green-600 pl-20 pt-3 text-sm">
                  Photo id uploaded successfully
                </p>
              )}
            </div>
            <div className="w-[40%]">
              <input
                type="file"
                accept="image/*,.pdf"
                onChange={(e) => handleFileUpload(e, 'address_id')}
                className="hidden"
                id="addressUpload"
              />

              <label
                htmlFor="addressUpload"
                onClick={() => {
                  if (stream) {
                    stream.getTracks().forEach((track) => track.stop());
                  }
                  setCameraOpen(false);
                }}
                className="border-2 border-dashed border-gray-300 rounded-lg p-6 flex items-center justify-center cursor-pointer bg-[#F7F9FB] min-h-[120px]"
              >
                <p className="font-medium text-[#0B214E]">Upload Address ID <span className="text-sm font-normal text-gray-400"> </span></p>
              </label>

              {details.address_id && (
                <p className="text-green-600 pl-20 pt-3 text-sm">
                  Address id uploaded successfully
                </p>
              )}
            </div>
            <div className="w-[20%] flex items-center">
              {!cameraOpen && (
                <PrimaryButton
                  label={'Capture Photo'}
                  onClick={openCamera}
                  style={{ width: '100%' }}
                />
              )}
            </div>
            {cameraOpen && (
              <div className="mt-4 text-center w-full">
                <video
                  ref={videoRef}
                  autoPlay
                  playsInline
                  className="w-72 mx-auto border rounded-lg"
                ></video>

                <canvas ref={canvasRef} style={{ display: 'none' }}></canvas>

                <PrimaryButton
                  label={'Capture'}
                  onClick={capturePhoto}
                  style={{ marginTop: '10px', width: '200px' }}
                />
              </div>
            )}
          </div>
          <input
            type="text"
            required={true}
            placeholder={'First Name'}
            className="w-full p-3 outline-none rounded-2xl border text-[#252528] font-semibold placeholder:text-sm placeholder:text-slate-700"
            onChange={(e) => {
              setDetails({ ...details, first_name: e.target.value });
              setErrors({ ...errors, first_name: '' });
            }}
          />
          {errors.first_name && (
            <p className="text-red-500 text-sm mt-1">{errors.first_name}</p>
          )}

          <input
            type="text"
            required={true}
            placeholder={'Last Name'}
            className="w-full p-3 outline-none rounded-2xl border text-[#252528] font-semibold placeholder:text-sm placeholder:text-slate-700"
            onChange={(e) => {
              setDetails({ ...details, last_name: e.target.value });
              setErrors({ ...errors, last_name: '' });
            }}
          />
          {errors.last_name && (
            <p className="text-red-500 text-sm mt-1">{errors.last_name}</p>
          )}

          <AddressSearchInput
            required={true}
            placeholder={'Address'}
            value={details.address_line1}
            className="w-full p-3 outline-none rounded-2xl border text-[#252528] font-semibold placeholder:text-sm placeholder:text-slate-700"
            onChange={(text) => {
              setDetails({ ...details, address_line1: text });
              setErrors({ ...errors, address_line1: '' });
            }}
            onPlaceSelected={(place) => {
              setDetails((prev) => ({
                ...prev,
                // Keep the full selected text if Google returns no street part
                address_line1: place.addressLine1 || prev.address_line1,
                // Replace all address fields; ones Google lacks are cleared so old values don't mix in
                city: place.city,
                post_code: place.postcode,
                country: place.country,
              }));
              setErrors((prev) => ({
                ...prev,
                city: place.city ? '' : "We couldn't detect your town, please enter it.",
                post_code: place.postcode ? '' : "We couldn't find a post code, please enter it.",
                country: '',
              }));
            }}
          />
          {errors.address_line1 && (
            <p className="text-red-500 text-sm mt-1">{errors.address_line1}</p>
          )}

          <input
            type="text"
            required={true}
            placeholder={'City'}
            value={details.city || ''}
            className="w-full p-3 outline-none rounded-2xl border text-[#252528] font-semibold placeholder:text-sm placeholder:text-slate-700"
            onChange={(e) => {
              setDetails({ ...details, city: e.target.value });
              setErrors({ ...errors, city: '' });
            }}
          />
          {errors.city && (
            <p className="text-red-500 text-sm mt-1">{errors.city}</p>
          )}
          <input
            type="text"
            required={true}
            placeholder={'Post Code'}
            value={details.post_code || ''}
            className="w-full p-3 outline-none rounded-2xl border text-[#252528] font-semibold placeholder:text-sm placeholder:text-slate-700"
            onChange={(e) => {
              setDetails({ ...details, post_code: e.target.value });
              setErrors({ ...errors, post_code: '' });
            }}
          />
          {errors.post_code && (
            <p className="text-red-500 text-sm mt-1">{errors.post_code}</p>
          )}

          <input
            type="text"
            required={true}
            placeholder={'Country'}
            value={details.country || ''}
            className="w-full p-3 outline-none rounded-2xl border text-[#252528] font-semibold placeholder:text-sm placeholder:text-slate-700"
            onChange={(e) => {
              setDetails({ ...details, country: e.target.value });
              setErrors({ ...errors, country: '' });
            }}
          />
          {errors.country && (
            <p className="text-red-500 text-sm mt-1">{errors.country}</p>
          )}

          <div className="relative w-full" ref={nationalityRef}>
            <button
              type="button"
              className={`w-full p-3 outline-none rounded-2xl border font-semibold bg-white text-left flex justify-between items-center ${details.nationality ? 'text-[#252528]' : 'text-sm text-slate-700'
                }`}
              onClick={() => {
                setNationalityOpen(!nationalityOpen);
                setNationalitySearch('');
              }}
            >
              <span>{details.nationality || 'Nationality'}</span>
              <span className="text-xs">{nationalityOpen ? '▲' : '▼'}</span>
            </button>
            {nationalityOpen && (
              <div className="absolute z-20 mt-1 w-full bg-white border rounded-2xl shadow-lg">
                <input
                  type="text"
                  autoFocus
                  value={nationalitySearch}
                  placeholder="Search country..."
                  className="w-full p-3 outline-none border-b rounded-t-2xl text-[#252528] placeholder:text-sm placeholder:text-slate-500"
                  onChange={(e) => setNationalitySearch(e.target.value)}
                />
                <ul className="max-h-60 overflow-y-auto">
                  {filteredNationalities.length > 0 ? (
                    filteredNationalities.map((c) => (
                      <li
                        key={c.id}
                        className={`px-3 py-2 cursor-pointer hover:bg-slate-100 text-[#252528] ${details.nationality === c.name ? 'bg-slate-100 font-semibold' : ''
                          }`}
                        onClick={() => {
                          setDetails({ ...details, nationality: c.name });
                          setErrors({ ...errors, nationality: '' });
                          setNationalityOpen(false);
                        }}
                      >
                        {c.name}
                      </li>
                    ))
                  ) : (
                    <li className="px-3 py-2 text-sm text-slate-500">No countries found</li>
                  )}
                </ul>
              </div>
            )}
          </div>
          {errors.nationality && (
            <p className="text-red-500 text-sm mt-1">{errors.nationality}</p>
          )}

          <input
            type="text"
            required={true}
            placeholder={'Place of Birth'}
            className="w-full p-3 outline-none rounded-2xl border text-[#252528] font-semibold placeholder:text-sm placeholder:text-slate-700"
            onChange={(e) => {
              setDetails({ ...details, place_of_birth: e.target.value });
              setErrors({ ...errors, place_of_birth: '' });
            }}
          />
          {errors.place_of_birth && (
            <p className="text-red-500 text-sm mt-1">{errors.place_of_birth}</p>
          )}

          <input
            type="date"
            required={true}
            placeholder={'Date of Birth'}
            className="w-full p-3 outline-none rounded-2xl border text-[#252528] font-semibold placeholder:text-sm placeholder:text-slate-700"
            onChange={(e) => {
              setDetails({ ...details, date_of_birth: e.target.value });
              setErrors({ ...errors, date_of_birth: '' });
            }}
          />
          {errors.date_of_birth && (
            <p className="text-red-500 text-sm mt-1">{errors.date_of_birth}</p>
          )}

          <PrimaryButton
            label={'Create'}
            loading={loading}
            onClick={submitHandler}
            style={{ width: '100%' }}
          />
        </div>
      </div>
    </div>
  );
}

export default UserDetails;